"use client";

import { useEffect } from "react";

import { APP_STARTUP_READY_EVENT } from "@/components/startup/app-startup-screen";
import { postMarketingEvent } from "@/lib/marketing/events-client";

declare global {
  interface Window {
    __hideUltrackStartup?: (reason?: string) => void;
  }
}

/**
 * Public-page boot island.
 *
 * The root layout renders a full-screen black startup overlay that only hides
 * itself when the app shell dispatches APP_STARTUP_READY_EVENT (or after a 12s
 * timeout). This marketing page never boots the app shell, so we dismiss the
 * overlay ourselves on mount, then record an anonymous page view.
 *
 * Renders nothing.
 */
export function MarketingBoot() {
  useEffect(() => {
    // Dismiss the startup overlay so anonymous visitors don't see a black
    // screen for up to 12s. Dispatch the event the overlay listens for, and
    // defensively call the imperative hook the layout exposes on window.
    try {
      window.dispatchEvent(new Event(APP_STARTUP_READY_EVENT));
    } catch {
      // Best-effort: never block rendering on the overlay handshake.
    }
    window.__hideUltrackStartup?.("marketing");

    // Fire-and-forget anonymous page view (never throws).
    void postMarketingEvent("marketing_page_view");
  }, []);

  return null;
}
